import { useEffect, useState } from "react";
import { fetchTokenIcon } from "./utils/fetchTokenIcon";

// Resolves a token's logo from Jupiter metadata. Used for partner reward tokens
// (e.g. ANSEM) that aren't part of the Kyros token list and have no bundled asset.
//
// Resolution order for the consumer: static override (if provided) -> this hook's
// result -> coloured monogram fallback rendered by <TokenIcon />.
export const useTokenIcon = (mint: string | undefined): string | undefined => {
  const [icon, setIcon] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!mint) {
      setIcon(undefined);
      return;
    }

    let cancelled = false;

    fetchTokenIcon(mint).then((logo) => {
      if (!cancelled && logo) setIcon(logo);
    });

    return () => {
      cancelled = true;
    };
  }, [mint]);

  return icon;
};
